<template>
	<footer class="footer">
		<!-- <p class="linkLine">
			<a v-for="(item,index) in link" :key="index" :href="item.src" target="_blank">{{item.name}}</a>
		</p> -->
		<p
			class="icp"
			v-html="footerText"
		/>
	</footer>
</template>
<script>
export default {
	name: 'LoginFooter',
	computed: {
		footerText() {
			return this.$t('components.loginFooter.copyright', {
				year: new Date().getFullYear()
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.footer {
	width: 100%;
	text-align: center;
	padding: 16px;
	box-sizing: border-box;
	&.mobile {
		.linkLine {
			padding-bottom: 13px;
			a {
				margin-right: 10px;
			}
		}
	}

	.linkLine {
		line-height: 15px;
		padding-bottom: 28px;
		a {
			font-size: 14px;
			color: #666666;
			margin-right: 30px;
		}
	}
	.desc {
		font-size: 12px;
		color: #999999;
		letter-spacing: 0;
	}
	.icp {
		line-height: 20px;
		font-size: 10px;
		color: #999999;
	}
}
</style>
